import React from 'react';
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from 'react-hot-toast';

import { AuthProvider, AuthContext } from './contexts/AuthContext';
import Main from './components/Main';
import Auth from './components/Auth';
import ErrorBoundary from './components/ErrorBoundary';

const App = () => {

  return (
    <HelmetProvider>
      <ErrorBoundary>
        <AuthProvider>
          <AuthContext.Consumer>
            {ctx => (ctx.isLoggedIn && ctx.ownerPortalUserId) ? (
              <ErrorBoundary>
                <Main />
              </ErrorBoundary>
            ) : (
              <ErrorBoundary>
                <Auth />
              </ErrorBoundary>
            )}
          </AuthContext.Consumer>

          <Toaster />
        </AuthProvider>
      </ErrorBoundary>
    </HelmetProvider>
  );
};

export default App;
